// import { getDictionariesCom } from '@/utils/index.js'

export default {
  props: {},
  data () {
    return {
      preview: {
        title: '送礼新思路！更是一门“新艺术”！邀您...',
        image: 'https://fenxiao.muruji.com/internalSystem/0f4ad5c8-f976-405d-b6b6-099cc9acc443',
        logo: 'http://app.jiuhangyunxuan.com/static/img/loginLogo.37e7e255.png',
        platform: '九航云选',
        inviter: 'xxx',
        grade: '黄金',
        content: ''
      },
      dialog: { visible: false, title: '编辑', type: '', row: {}, list: [], batch: false, titleArr: [] },
    }
  },
  computed: {},
  filters: {},
  created () {},
  methods: {
    showDialog (type, row) {
      // console.log('showModifyState', skuList, titleArr)
      this.setCloseOrder = ''
      this.dialog.visible = true
      this.dialog.title = '预览'
      this.dialog.width = '1265px'
      this.dialog.type = 'add'
      // this.dialog.row = row
    },
    submitDialog () {
      this.dialog.visible = false
      // this.$message.success('已返回')
    },
  }
}
